import * as React from "react";
import { Consumer } from "../libs/AuthContext";
import { Dropdown, Checkbox, Divider, Header, Grid, Segment, Button} from "semantic-ui-react";
import { translate } from "react-i18next";

class Settings extends React.Component {

  colourPalettes = [
    {
    title: "Default",
    palette: {
      backgroundLight: "#FFFFFF",
      backgroundDark: "#202020",
      foregroundLight: "#FFFFFF",
      foregroundDark: "#202020",
      accent: "#d48872"
      },
    },
    {
    title: "Night",
    palette: {
        backgroundLight: "#303030",
        backgroundDark: "#424242",
        foregroundLight: "#ffffffb3",
        foregroundDark: "#ffffff",
        accent: "#d48872"
      },
    },
    {
    title: "Sepia",
    palette: {
        backgroundLight: "#f9e6d9",
        backgroundDark: "#e4d1c4",
        foregroundLight: "#776965",
        foregroundDark: "#4c413e",
        accent: "#7a5b48"
      }
    }
  ]
  colourOptions =
  [
    { key: "default", text: "Default", value: "Default" },
    { key: "night", text: "Night", value: "Night" },
    { key: "sepia", text: "Sepia", value: "Sepia" }
  ];
  fontPalettes = [
    {
      title: "All Sans",
      fontSet: {
        fontFaces: [],
        defaults: {
          fallback: "sans-serif"
        }
      }
    },
    {
      title: "Default",
      fontSet: undefined
    }
  ]
  fontOptions =
  [
    { key: "default", text: "Default", value: "Default" },
    { key: "allsans", text: "All Sans", value: "All Sans" }
  ];
  rendererOptions =
  [
    { key: "flipbookRenderer", text: "Flip Book", value: "flipbookRenderer" },
    { key: "stackRenderer", text: "Stack", value: "stackRenderer" },
    { key: "verticalScrollRenderer", text: "Vertical Scroll", value: "verticalScrollRenderer" }
  ]
  constructor(props) {
    super(props);
    this.pubLoader = this.props.context.pubLoader
    this.state = {
      darkTheme: false,
      fontSize: 100,
      lineHeight: 100,
      verticalMargin: 6,
      horizontalMargin: 5,
      colourTheme: this.colourPalettes[0],
      fontTheme: this.fontPalettes[0],
      backgroundColor: "#FFFFFF",
      value: { min: 2, max: 10 },
      renderer: ""
    }
  }

  async componentDidMount() {
    this.engine = this.pubLoader.getEngine()
    this.view = this.pubLoader.getView()
    this.readerPublication = this.pubLoader.getReaderPublications()
    let sampleBack = document.getElementById("sampleBack")
    let sampleText = document.getElementById("sampleText")
    this.setState({ darkTheme: this.props.context.pubLoader.backgroundColor === "#FFFFFF" ? false : true })
    let currentOptions= this.engine.getOptions().publicationStyleOptions;
      this.setState({
        fontSize: currentOptions.fontSizeScaleFactor ? Math.round(currentOptions.fontSizeScaleFactor*100) : 1,
        lineHeight: currentOptions.lineHeightScaleFactor ? Math.round(currentOptions.lineHeightScaleFactor*100) : 1,
        horizontalMargin: currentOptions.pageMarginHorizontal ? currentOptions.pageMarginHorizontal : 6,
        verticalMargin: currentOptions.pageMarginVertical ? currentOptions.pageMarginVertical : 5,
        renderer: this.pubLoader.renderer
      });
    let currentFont = this.fontPalettes.filter(item => item.title === this.pubLoader.fontTheme);
    if (currentFont) {
      this.setState({ fontTheme: currentFont[0]})
    }
    let currentColor = this.colourPalettes.filter(item => item.title === this.pubLoader.colorTheme);
    if (currentColor) {
      this.setState({ colourTheme: currentColor[0]})
    }
    if (sampleBack && sampleText && currentOptions) {
      sampleText.style.fontSize = currentOptions.fontSizeScaleFactor ? Math.round(currentOptions.fontSizeScaleFactor*100)+"%" : "100%"
      sampleText.style.lineHeight = currentOptions.lineHeightScaleFactor ? (Math.round(currentOptions.lineHeightScaleFactor)+0.2).toString() : "1"
      sampleText.style.paddingTop = currentOptions.pageMarginVertical ? (currentOptions.pageMarginVertical/10 +1 ).toString()+"em": "6em"
      sampleText.style.paddingBottom = currentOptions.pageMarginVertical ? (currentOptions.pageMarginVertical/10 +1 ).toString()+"em": "6em"
      sampleText.style.paddingLeft = currentOptions.pageMarginHorizontal ? (currentOptions.pageMarginHorizontal/10 +1 ).toString()+"em": "5em"
      sampleText.style.paddingRight = currentOptions.pageMarginHorizontal ? (currentOptions.pageMarginHorizontal/10 +1 ).toString()+"em": "5em"
    }
    if (sampleBack && sampleText) {
      sampleText.style.backgroundColor = currentColor[0].palette.backgroundLight;
      sampleBack.style.backgroundColor = currentColor[0].palette.backgroundLight;
      if (currentColor[0].title === "Night") {
        sampleText.style.color = "#FFFFFF";
      }
      else {
        sampleText.style.color = "#303030";
      }
    }
  }


 toggleDarkTheme = () => {
    this.setState({ darkTheme: !this.state.darkTheme, backgroundColor: this.state.darkTheme ? "#303030" : "#FFFFFF"  })
    this.view = this.pubLoader.getView()
    this.view.setRendererOptions({
        pageBackgroundColor: this.state.darkTheme ? "#303030" : "#FFFFFF"
    })
    let sampleText = document.getElementById("sampleBack")
    if (sampleText) {
      if (!this.state.darkTheme) {
        sampleText.style.backgroundColor = "#303030";
      }
      else {
        sampleText.style.backgroundColor = "#FFFFFF";
      }
    }
    this.pubLoader.backgroundColor =  this.state.darkTheme ? "#FFFFFF" : "#303030";
  }

 updateStyling(fontTheme, colourTheme, fontSize, lineHeight, horizontalMargin, verticalMargin )  {
    let options = {
      fontSizeScaleFactor: fontSize ? fontSize / 100 : this.state.fontSize / 100,
      lineHeightScaleFactor: lineHeight ? lineHeight /100 : this.state.lineHeight / 100,
      pageMarginHorizontal: horizontalMargin ? horizontalMargin : this.state.horizontalMargin,
      pageMarginVertical: verticalMargin ? verticalMargin : this.state.verticalMargin,
      palette: colourTheme ? colourTheme.palette : this.state.colourTheme.palette,
      fontSet: fontTheme ? fontTheme.fontSet : this.state.fontTheme.fontSet,
    }
    this.engine.setOptions({
        publicationStyleOptions: options
    });
    try{
    this.view = this.pubLoader.getView();
    this.view.refresh();
    this.view.setRendererOptions({
        pageBackgroundColor: this.state.backgroundColor
    })
  } catch (e) {
    console.log(e);

  }

  }

 updateFont = (val) => {
    this.setState({ fontSize: val})
    let sampleText = document.getElementById("sampleText")
    if (sampleText) {
      sampleText.style.fontSize = val+"%"
    }
    this.updateStyling(this.state.fontTheme, this.state.colourTheme, val);
  }
 updateLine = (val) => {
    this.setState({ lineHeight: val})
    let sampleText = document.getElementById("sampleText")
    if (sampleText) {
      sampleText.style.lineHeight = ( val/100+0.2).toString()
    }
    this.updateStyling(this.state.fontTheme, this.state.colourTheme, this.state.fontSize ,val);
  }
 updateHorizontal = (val) => {
    this.setState({ horizontalMargin: val})
    let sampleText = document.getElementById("sampleText")
    if (sampleText) {
        sampleText.style.paddingLeft = (val/10 + 1).toString()+"em";
        sampleText.style.paddingRight = (val/10 + 1).toString()+"em";
    }
    this.updateStyling(this.state.fontTheme, this.state.colourTheme, this.state.fontSize , this.state.lineHeight ,val);
  }
 updateVertical = (val) => {
    this.setState({ verticalMargin: val})
    let sampleText = document.getElementById("sampleText")
    if (sampleText) {
        sampleText.style.paddingTop = (val/10 + 1).toString()+"em";
        sampleText.style.paddingBottom = (val/10 + 1).toString()+"em";
    }
    this.updateStyling(this.state.fontTheme, this.state.colourTheme, this.state.fontSize , this.state.lineHeight , this.state.horizontalMargin ,val);
  }
 updateColour = (event, data) => {
    const colourTheme =  this.colourPalettes.filter(item => item.title.includes(data.value))
    {colourTheme.length > 0 &&
      this.setState({ colourTheme: colourTheme[0], backgroundColor: colourTheme[0].palette.backgroundDark });
      this.updateStyling( this.state.fontTheme, colourTheme[0] );
      this.pubLoader.colorTheme = colourTheme[0].title
      this.pubLoader.backgroundColor =  colourTheme[0].palette.backgroundLight
      let sampleText = document.getElementById("sampleText")
      let sampleBack = document.getElementById("sampleBack")
      if (sampleText && sampleBack) {
        sampleText.style.backgroundColor = colourTheme[0].palette.backgroundLight;
        sampleBack.style.backgroundColor = colourTheme[0].palette.backgroundLight;
        if (colourTheme[0].title === "Night") {
          sampleText.style.color = "#FFFFFF";
        }
        else {
          sampleText.style.color = "#303030";
        }
      }
    }
  }
 updateText = (event, data) => {
   const fontTheme =  this.fontPalettes.filter(item => item.title.includes(data.value))
   { fontTheme.length > 0 &&
     this.setState({ fontTheme: fontTheme[0] });
     this.pubLoader.fontTheme = fontTheme[0].title
     this.updateStyling(fontTheme[0]);
     let sampleText = document.getElementById("sampleText")
     if (sampleText && fontTheme[0].title === "All Sans") {
       sampleText.style.fontFamily = "sans-serif"
     }
     else if (sampleText)  {
       sampleText.style.fontFamily = "serif"
     }
   }
  }

 render() {
    const { t } = this.props
    return (
      <div className="settings" style={{paddingTop: "1em"}}>
        <Grid columns={2} textAlign="center">
          <Grid.Row style={{width: "50%"}}>
            <Segment style={{boxShadow: "0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5"}} id="sampleBack">
              <div style={{boxShadow: "0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5", padding: "1em", width: "100%", color: "black", backgroundColor: "#FFFFFF"}} className="sampleText" id="sampleText">
              at imperdiet dui accumsan sit amet nulla facilisi morbi tempus iaculis urna id volutpat lacus laoreet non curabitur gravida arcu ac tortor dignissim convallis aenean et tortor at risus viverra adipiscing at in tellus integer feugiat scelerisque varius morbi enim nunc faucibus a pellentesque sit amet porttitor eget dolor morbi non arcu risus quis varius quam quisque id diam vel quam elementum pulvinar etiam non quam lacus suspendisse faucibus interdum posuere lorem ipsum
              </div>
              <div style={{boxShadow: "0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5", padding: "1em", width: "100%", color: "black", backgroundColor: "#FFFFFF"}} className="sampleTextMobile" id="sampleText">
              at imperdiet dui accumsan sit amet nulla facilisi morbi tempus iaculis urna id volutpat lacus laoreet non curabitur gravida arcu ac tortor dignissim convallis
              </div>
            </Segment>
          </Grid.Row>
          {this.pubLoader.epubFormat === "REFLOWABLE" ?
            <Grid.Row>
              <Grid.Column >
                <Checkbox toggle
                  checked={this.state.darkTheme}
                  onChange={this.toggleDarkTheme}
                />
                <p className="checkBoxText">{t("Apply Dark Theme")}</p>
                <Header as="h4">{t("Color Theme")} </Header>
                <Dropdown
                  compact
                  id="colourTheme"
                  onChange={this.updateColour}
                  selection options={this.colourOptions}
                  value={this.state.colourTheme.title}
                />
                <br/>
                <Header as="h4">{t("Font Theme")}</Header>
                <Dropdown
                  compact
                  id="fontTheme"
                  onChange={this.updateText}
                  selection options={this.fontOptions}
                  value={this.state.fontTheme.title}
                />
              </Grid.Column>
              <Grid.Column>
                <Header as="h4">{t("Font Size")}</Header>
                <div style={{display: "-webkit-inline-box"}}>
                <Button icon="minus" onClick={() => {this.updateFont(this.state.fontSize-5)}} style={{marginRight: "1em"}}/>
                <p>{this.state.fontSize}</p>
                <Button icon="plus" onClick={() => {this.updateFont(this.state.fontSize+5)}} style={{marginLeft: "1em"}}/>
                </div>

                <Header as="h4">{t("Line Height")}</Header>
                <div style={{display: "-webkit-inline-box"}}>
                <Button icon="minus" onClick={() => {this.updateLine(this.state.lineHeight-5)}} style={{marginRight: "1em"}}/>
                <p>{this.state.lineHeight}</p>
                <Button icon="plus" onClick={() => {this.updateLine(this.state.lineHeight+5)}} style={{marginLeft: "1em"}}/>
                </div>
                <Divider hidden />

                <Header as="h4">{t("Verical Margin")}</Header>
                <div style={{display: "-webkit-inline-box"}}>
                <Button icon="minus" onClick={() => {this.updateVertical(this.state.verticalMargin-1)}} style={{marginRight: "1.6em"}}/>
                <p style={{marginRight: "0.5em"}}>{this.state.verticalMargin}</p>
                <Button icon="plus" onClick={() => {this.updateVertical(this.state.verticalMargin+1)}} style={{marginLeft: "1em"}}/>
                </div>
                <Divider hidden />

                <Header as="h4">{t("Horizontal Margin")}</Header>
                <div style={{display: "-webkit-inline-box"}}>
                <Button icon="minus" onClick={() => {this.updateHorizontal(this.state.horizontalMargin-1)}} style={{marginRight: "1.6em"}}/>
                <p style={{marginRight: "0.5em"}}>{this.state.horizontalMargin}</p>
                <Button icon="plus" onClick={() => {this.updateHorizontal(this.state.horizontalMargin+1)}} style={{marginLeft: "1em"}}/>
                </div>
              </Grid.Column>
            </Grid.Row>
            :
            <Grid.Row>
              <Grid.Column >
                <Checkbox toggle
                  checked={this.state.darkTheme}
                  onChange={this.toggleDarkTheme}
                  label={t("Apply Dark Theme")}
                />
                <Header as="h4">{t("Color Theme")} </Header>
                <Dropdown
                  compact
                  id="colourTheme"
                  onChange={this.updateColour}
                  selection options={this.colourOptions}
                  value={this.state.colourTheme.title}
                />
                </Grid.Column>
                <Grid.Column>
                <Header as="h4">{t("Font Theme")}</Header>
                <Dropdown
                  compact
                  id="fontTheme"
                  onChange={this.updateText}
                  selection options={this.fontOptions}
                  value={this.state.fontTheme.title}
                />
              </Grid.Column>
            </Grid.Row>
          }
        </Grid>
      </div>
    )
  }

}

export default translate("translations")(props =>
  <Consumer>
    {value => <Settings {...props} context={value} />}
  </Consumer>
);
